export const OUTSOURCE_MAIN_STEPS = [
  {
    step: 'Предпроектная аналитика',
    subSteps: ['формирование системных требований', 'проектирование архитектуры', 'дизайн концепт']
  },
  { step: 'Разработка двухнедельными спринтами' },
  { step: 'Финальное предрелизное тестирование' },
  { step: 'Регулярные релизы' },
  { step: 'Поддержка и развитие продукта' }
]

export const OUTSOURCE_TEAM = [
  [
    { lead: 'Владелец продукта' },
    { lead: 'Ведущий системный аналитик', workers: [{ position: 'Системный аналитик' }] },
    { lead: 'Ведущий дизайнер интерфейсов', workers: [{ position: 'Дизайнер интерфейсов' }] },
    { lead: 'Ведущий специалист технической поддержки', workers: [{ position: 'Специалист технической поддержки' }] }
  ],
  [
    { lead: 'Руководитель ИТ-проекта' },
    {
      lead: 'Технический лидер проекта',
      workers: [
        { position: 'Системный архитектор' },
        { position: 'Разработчик серверной части' },
        { position: 'Разработчик клиентской части' },
        { position: 'Разработчик мобильных приложений' }
      ]
    }
  ],
  [{ lead: 'Клиентский менеджер' }, { lead: 'Ведущий инженер-тестировщик', workers: [{ position: 'Инженер-тестировщик' }] }]
]

export const OUTSOURCE_TEAM_ADAPTIVE = [
  [
    { lead: 'Владелец продукта' },
    { lead: 'Ведущий системный аналитик', workers: [{ position: 'Системный аналитик' }] },
    { lead: 'Ведущий дизайнер интерфейсов', workers: [{ position: 'Дизайнер интерфейсов' }] },
    { lead: 'Ведущий инженер-тестировщик', workers: [{ position: 'Инженер-тестировщик' }] },
    { lead: 'Ведущий специалист технической поддержки', workers: [{ position: 'Специалист технической поддержки' }] }
  ],

  [
    { lead: 'Клиентский менеджер' },
    { lead: 'Руководитель ИТ-проекта' },
    {
      lead: 'Технический лидер проекта',
      workers: [
        { position: 'Системный архитектор' },
        { position: 'Разработчик серверной части' },
        { position: 'Разработчик клиентской части' },
        { position: 'Разработчик мобильных приложений' }
      ]
    }
  ]
]

export const OUTSTAFF_MAIN_STEPS = [
  { step: 'Подключаемся к проекту заказчика' },
  { step: 'В процессе погружения в проект, проводим аудит процессов заказчика' },
  { step: 'Помогаем выстроить разработку' },
  { step: 'Усиливаем текущую команду' },
  { step: 'Делимся экспертизой и успешными практиками' },
  { step: 'Поддерживаем и развиваем продукт' }
]

export const OUTSTAFF_TEAM = [
  [{ lead: 'Клиентский менеджер' }, { lead: 'Ведущий системный аналитик', workers: [{ position: 'Системный аналитик' }] }],
  [
    {
      lead: 'Технический лидер проекта',
      workers: [
        { position: 'Системный архитектор' },
        { position: 'Разработчик серверной части' },
        { position: 'Разработчик клиентской части' },
        { position: 'Разработчик мобильных приложений' }
      ]
    }
  ],
  [{ lead: 'Ведущий инженер-тестировщик', workers: [{ position: 'Инженер-тестировщик' }] }]
]

export const OUTSTAFF_TEAM_ADAPTIVE = [
  [
    { lead: 'Клиентский менеджер' },
    {
      lead: 'Технический лидер проекта',
      workers: [
        { position: 'Системный архитектор' },
        { position: 'Разработчик серверной части' },
        { position: 'Разработчик клиентской части' },
        { position: 'Разработчик мобильных приложений' }
      ]
    }
  ],

  [
    { lead: 'Ведущий системный аналитик', workers: [{ position: 'Системный аналитик' }] },
    { lead: 'Ведущий инженер-тестировщик', workers: [{ position: 'Инженер-тестировщик' }] }
  ]
]

export const TECH_STACK_TEAM = [
  [
    { 
      lead: 'Бэкенд',
      workers: [
        { position: 'Go' },
        { position: 'Java' },
        { position: 'Python' },
        { position: 'PHP' }
      ]
    }
  ],
  [
    { 
      lead: 'Фронтенд',
      workers: [
        { position: 'Vue.js' },
        { position: 'React' },
        { position: 'TypeScript' },
        { position: 'Next.js' },
        { position: 'Angular' },
        { position: 'Bootstrap' }
      ]
    }
  ],
  [
    { 
      lead: 'Эксплуатация и инфраструктура',
      workers: [
        { position: 'PostgreSQL' },
        { position: 'ClickHouse' },
        { position: 'Redis' },
        { position: 'Docker' },
        { position: 'GitLab CI' },
        { position: 'Nginx' },
        { position: 'Kubernetes' },
        { position: 'Prometheus' }
      ]
    }
  ],
  [
    { 
      lead: 'Протоколы, интеграции',
      workers: [
        { position: 'OIDC' },
        { position: 'gRPC' },
        { position: 'OAuth' },
        { position: 'REST' },
        { position: 'Protobuf' }
      ]
    }
  ],
]

export const TECH_STACK_TEAM_ADAPTIVE = [
  [
    { 
      lead: 'Бэкенд',
      workers: [
        { position: 'Go' },
        { position: 'Java' },
        { position: 'Python' },
        { position: 'PHP' }
      ]
    },
    { 
      lead: 'Фронтенд',
      workers: [
        { position: 'Vue.js' },
        { position: 'React' },
        { position: 'TypeScript' },
        { position: 'Next.js' },
        { position: 'Angular' },
        { position: 'Bootstrap' }
      ]
    },
    { 
      lead: 'Эксплуатация и инфраструктура',
      workers: [
        { position: 'PostgreSQL' },
        { position: 'ClickHouse' },
        { position: 'Redis' },
        { position: 'Docker' },
        { position: 'GitLab CI' },
        { position: 'Nginx' },
        { position: 'Kubernetes' },
        { position: 'Prometheus' }
      ]
    },
    { 
      lead: 'Протоколы, интеграции',
      workers: [
        { position: 'OIDC' },
        { position: 'gRPC' },
        { position: 'OAuth' },
        { position: 'REST' },
        { position: 'Protobuf' }
      ]
    }
  ]
]